module.exports = __webpack_public_path__ + "worldnews_icon.svg?43e52ccb2e6dbab25b95ae5904699e47";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/worldnews_icon.svg
// module id = 1078
// module chunks = 30